import { Foundation } from 'foundation-sites/js/foundation.core'
import { Drilldown } from 'foundation-sites/js/foundation.drilldown';
import { Dropdown } from 'foundation-sites/js/foundation.dropdown';
// import { Accordion } from 'foundation-sites/js/foundation.accordion';
import { Tabs } from 'foundation-sites/js/foundation.tabs'
import { Box } from 'foundation-sites/js/foundation.util.box'
import { onImagesLoaded } from 'foundation-sites/js/foundation.util.imageLoader';
import { Keyboard } from 'foundation-sites/js/foundation.util.keyboard';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
import { Motion, Move } from 'foundation-sites/js/foundation.util.motion';
import { Nest } from 'foundation-sites/js/foundation.util.nest';
import { Interchange } from 'foundation-sites/js/foundation.interchange';
import { Timer } from 'foundation-sites/js/foundation.util.timer';
import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas';
import { Orbit } from 'foundation-sites/js/foundation.orbit';
import { Reveal } from 'foundation-sites/js/foundation.reveal';
// import { ResponsiveAccordionTabs } from 'foundation-sites/js/foundation.responsiveAccordionTabs';

function initFoundation() {
  Foundation.Box = Box
  Foundation.onImagesLoaded = onImagesLoaded
  Foundation.Keyboard = Keyboard
  Foundation.MediaQuery = MediaQuery
  Foundation.Motion = Motion
  Foundation.Move = Move
  Foundation.Nest = Nest
  Foundation.Timer = Timer

  // Include the Foundation Modules that we'll use in the app
  // Foundation.plugin(Tabs, 'Tabs')
  // Foundation.plugin(Accordion, 'Accordion')
  // Foundation.plugin(ResponsiveAccordionTabs, 'ResponsiveAccordionTabs')
  Foundation.plugin(Dropdown,'Dropdown')
  Foundation.plugin(Drilldown, 'Drilldown')
  Foundation.plugin(OffCanvas, 'OffCanvas')
  Foundation.plugin(Orbit, 'Orbit')
  Foundation.plugin(Reveal, 'Reveal')
  Foundation.plugin(Interchange, 'Interchange')
  // Add jQuery to Foundation
  Foundation.addToJquery(jQuery)

  // Kick off foundation
  jQuery(document).foundation()
}

export default initFoundation
